import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'swipesum-header',
    templateUrl: './swipesum-header.component.html',
    styleUrls: ['./swipesum-header.component.scss'],
    standalone: false
})
export class SwipesumHeaderComponent {

    @Input() appName: string = 'Swipesum';  
    @Input() homeLink: string = '/';
    constructor(private readonly router: Router) { }

    ngOnInit(): void {
    }

    navigateToHome() {
        this.router.navigateByUrl(this.homeLink);
    }
}